// Samp Logs


const SampleLogs =  [


// Begin log_ ------Waterski club ------------ >>

  {
    id: 'log_8', // group Waterski club
    type: 'group', // company, group, organization, other
    
    
    otherPartyId: 'group_2',
    logDate: "2021-01-08T08:01:00.000Z",  // date input by user
    lastEdit:  "2021-01-08T08:01:00.000Z",  // Jan 8 2021 8:01 AM
    timeLock:  "",  // if exists - not editable
    
    meta: 'Mary, James, Tommy in attendance',
    title: 'Me CFO',
   
    detail : ' Waterski club put me in charge of finances.  Not something I really wanted.  I think a new spreadsheet is in order.', 
  
    attachment: '',
  
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
   peopleArray: ['Jerry G'], 
    
    keywordArray: [],
  
  },


  {
    id: 'log_4', // group Waterski club
    type: 'group', // company, group, organization, other
    otherPartyId: 'group_2',
    logDate: "2021-01-03T11:01:00.000Z",  // date input by user
    lastEdit:  "2021-01-03T11:01:00.000Z",  // Jan 3 2021 11:01 AM
    timeLock:  "",
    
    meta: '',
    title: '',
   
    detail : '<div><span style=\"color: rgb(206, 145, 120);\">Complained today that the finances of the club were in disarray, so they proposed I do the job.</span></div>', 
  
    attachment: '',
  
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
    
    peopleArray: ['Jerry G'],
    keywordArray: [],
  
  },


  {
    id: 'log_12', // group Waterski club
    type: 'group', // company, group, organization, other
    
    
    otherPartyId: 'group_2',
    logDate: "2021-01-07T08:01:00.000Z",  // date input by user
    lastEdit:  "2021-01-07T08:01:00.000Z",  // Jan 7 2021 8:01 AM
    timeLock:  "",  // if exists - not editable
    
    meta: '',
    title: '#3  me secretary',
   
    detail : 'The revenues for the next trip are less than our costs.   Going to have to charge more for the trip, or lower the cost of food.  Put it to a vote tonight.', 
  
    attachment: '',
  
    chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
   peopleArray: ['Jerry G'], 
    
    keywordArray: [],
  
  },
  

  // Begin log_ ------Shelly ------------ >>
 
    {
      id: 'log_1', // person - Shelly
      type: 'person', // company, group, organization, topic, story, other
      
      
      otherPartyId: 'person_4', //Shelly 

      logDate: "2021-01-03T10:01:00.000Z",  // date input by user
      lastEdit:  "2021-01-03T10:01:00.000Z",  // Jan 3 2021 10:01 AM
      timeLock:  "2021-01-03T10:01:00.000Z",  // if exists - not editable

      meta: '',
      title: '',
     
      detail : '<div>It started 2 months ago - I live in a large apartment&nbsp;complex.&nbsp;My upstairs neighbor (Shelly) would sit on the curb in front of my garage smoking cigarettes and brushing her long haired dog.&nbsp;</div><div>&nbsp;</div><div>She would leave all the hair - which was a lot - in front of my garage along with 2 or 3 cigarette butts - depending how long she brushed the dog.</div><div>&nbsp;</div><div>The first 2 times I cleaned them up because my dog would sometimes eat a butt and then regurgitate it in my apartment later.&nbsp;</div><div>&nbsp;</div><div>This 3rd time, when I saw her walking her dog I asked her to pick up the hair and butts when she was through.&nbsp;She was obviously not pleased with my request - and said she didn’t have to.</div><div>&nbsp;</div><div>The next time she did it (it occurs about every 10 days… I left a note on her door requesting she pick them up… I also kept a gave a copy for a file I started and gave a copy of the note to the main office of the complex to put on file.</div><div>&nbsp;</div><div>The office rep asked if she should say something to Shelly, I told her no.</div><div>&nbsp;</div><div>The fourth time Shelly left the hair and butts in front of my garage was December 27… that time I took a picture of it. I then picked up the hair and butts and left a 2nd note on her door and the butts and hair in a grocery bag in front.&nbsp;Also - gave a copy of the note to the front office again.</div><div>&nbsp;</div><div>She responded to my leaving the bag by emptying the bag on my front stoop.&nbsp;So I picked it up again.</div>', 

      attachment: '',

      chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
      
      peopleArray: ['Shelly-neighbor'],
      keywordArray: ['neighbor dispute'],

    },






{
  id: 'log_18', // person - Shelly
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_4', //Shelly 

  logDate: "2021-01-20T10:01:00.000Z",  // date input by user
  lastEdit:  "2021-01-20T10:01:00.000Z",  // Jan 6 2021 10:01 AM
  timeLock:   "2021-01-20T10:01:00.000Z",  // if exists - not editable

  meta: '',
  title: 'More poop on my driveway',
 
  detail : '<div>Escalation - Shelly did it again yesterday… left hair and butts in front of my garage.&nbsp;</div><div>&nbsp;</div><div>So this time took picture …&nbsp;left a note (again copy to the apartment complex) along with the hair and butts (sans bag) on her stoop.&nbsp;</div><div>&nbsp;</div><div>She responded by taking the hair I left and spread it over &nbsp;over my bushes surrounding my stoop -- and she also left a whole bunch of buts she must have had in an ash tray on my stoop.&nbsp;took a picture and then just cleaned it up.</div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  peopleArray: ['Shelly-neighbor'], 
  
  keywordArray: ['neighbor dispute'],

},




{
  id: 'log_9', // person - Shelly
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_4', //Shelly 

  logDate: "2021-01-05T10:01:00.000Z",  // date input by user
  lastEdit:  "2021-01-05T10:01:00.000Z",  // Jan 5 2021 10:01 AM
  timeLock:  "",  // if exists - not editable

  meta: '',
  title: '',
 
  detail : '<div> More hair and butts today… picture, copy of note to office… but this time I left the hair and butts I picked up on her car.</div><div> </div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
 peopleArray: ['Shelly-neighbor', 'Jerry G'], 
  
  keywordArray: ['neighbor dispute'],

},

{
  id: 'log_20', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_4', //Shelly 

  logDate: "2021-03-01T10:01:00.000Z",  
  lastEdit: "2021-03-01T10:01:00.000Z",
  timeLock:  '',

  meta: '',
  title: '',
 
  detail : "<div>Shelly is now leaving cigarette butts regularly on my doorstep .. almost daily.&nbsp;Started picking them up and keeping them in a jar.</div><div>&nbsp;</div><div>Today more hair and butts found out front … took picture - left a note … but this time didn’t retaliate - the note just said “I will contemplate an appropriate response and implement it later. “&nbsp;Hoping the note would just make her worry.</div>", 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: [''],

},


{
  id: 'log_21', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_4', //Shelly 

  logDate: "2021-03-05T10:01:00.000Z",  
  lastEdit: "2021-03-05T10:01:00.000Z",
  timeLock:  "2021-03-05T10:01:00.000Z",

  meta: 'Jim - neighbor has video',
  title: '',
 
  detail :  "<div>Yesterday Shelly’s 20 something daughter saw me walking the dog.&nbsp;She ran down the street to catch up with me.&nbsp;She then proceeded to threaten me … said if I left another note she would have her friends come and beat me up.&nbsp;</div><div>&nbsp;</div><div>The interesting thing was she was filming me on her phone while she was screaming her threats at me.</div><div>&nbsp;</div><div>Another neighbor heard the commotion and also filmed the incident with his phone.</div>", 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: [''],

},


{
  id: 'log_22', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_4', //Shelly 

  logDate: "2021-03-09T10:01:00.000Z",  
  lastEdit: "2021-03-09T10:01:00.000Z",
  timeLock:  "2021-03-09T10:01:00.000Z",

  meta: '<div><span style="color: rgb(153, 51, 255);">Officer Zipnick sheriff</span></div><div>2:20 PM </div>',
  title: '',
 
  detail : '<div><span style="color: rgb(230, 0, 0);">Shelly called the police</span> on me - said I was threatening her.&nbsp;Showed the police the last note I left and a 30 second slice of the 15 minute video her daughter had taken…. which out of context looked like a threat from me.&nbsp;</div><div>&nbsp;</div><div>An officer showed up - very cordial - told me about Shelly’s accusation.&nbsp;I showed him this log + the jar of cigarette butts she had left on my stoop and that I had picked up + the pictures and notes.&nbsp;&nbsp;Told the officer that the front office had copies of all the notes I had left for Shelly.</div><div>&nbsp;</div><div>Also explained to the officer what I had actually said on the video (in context without editing) … also that&nbsp;my other neighbor had a phone&nbsp;video of the whole exchange which would support my version.&nbsp;I offered to go get it - but he said it wasn’t necessary… he would go talk to Shelly.&nbsp;&nbsp;Then left.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: [],

},

//--- Cynn   Ter -------------------------------------


{
  id: 'log_23', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-06T10:01:00.000Z",  
lastEdit: "2021-01-06T10:01:00.000Z", 
  timeLock:  '',

  meta: 'location- Cynthia office',
  title: '',
 
  detail : '<div>One on one with Cyn concerning her responsibilities as the marketing team representative.&nbsp;Outlined her to do’s.&nbsp;Although she is not enthused to be on this team and told me so explicitly, she is professional .. so I’m excited with her being a part.</div><div>&nbsp;</div><div>She committed to getting us a market segmentation report for our meeting next Tuesday.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_24', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-12T16:01:00.000Z",  
lastEdit: "2021-01-12T16:01:00.000Z", 
  timeLock:  '',

  meta: 'meeting - cconference room',
  title: '',
 
  detail : '<div><strong style="color: rgb(230, 0, 0);">Cyn did not attend </strong>today’s meeting because of a conflict.&nbsp;So we didn’t get her segmentation report.&nbsp;Said she would get me a copy of the segmentation report tomorrow.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_26', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-16T16:01:00.000Z",  
lastEdit: "2021-01-16T16:01:00.000Z", 
  timeLock:  '',

  meta: '',
  title: '',
 
  detail : '<div> 2 text messages and an email …Still <strong>no report from Cyn.</strong>&nbsp;She finally got back to me this morning.&nbsp;She said she had to leave early today - I asked her to send it to the entire team by noon Monday so they could read it before Tuesday’s meeting.</div><div> </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_27', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-19T19:15:00.000Z",  
lastEdit:"2021-01-19T19:15:00.000Z",  
  timeLock:  '',

  meta: '<div>meeting - conference room</div>',
  title: '',
 
  detail : '<div>Cyn came to this morning’s meeting - a half hour late.&nbsp;Didn’t send out the report to the team.&nbsp;But she gave us a top line segmentation recommendation - but showed no write up or data to support her conclusions.&nbsp;Asked her to send the team the report to the team because product specification depended on the details… not just the top line conclusion.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_28', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-23T19:15:08.000Z",  
lastEdit:"2021-01-23T19:15:08.000Z",  
  timeLock:  '',

  meta: '',
  title: '',
 
  detail : '<div>Still no report - emailed her another request for the segmentation report but this time copied her boss.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},



{
  id: 'log_29', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-23T19:15:08.000Z",  
lastEdit:"2021-01-23T19:15:08.000Z",  
  timeLock:  '',

  meta: '',
  title: '',
 
  detail : '<div><span style="color: rgb(0, 71, 178);">Team received the report from Cyn t this morning. -- 2 weeks late.&nbsp;</span>The good news is the segmentation report was pretty good.&nbsp;&nbsp;Told her the next thing we need from her is marketing’s feature wish list.&nbsp;&nbsp;</div><div>&nbsp;</div><div>The late segmentation report has already put us behind the schedule we agreed upon.&nbsp;Stressed that we needed the feature list ASAP so engineering could look it over and respond with a real timeline for a prototype of the MVP.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_30', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-26T19:15:08.000Z",  
lastEdit:"2021-01-26T19:15:08.000Z",  
  timeLock:  '',

  meta: '',
  title: '',
 
  detail : 'Cyn missed today’s meeting again… another unexplained conflict.&nbsp;</div><div>&nbsp;</div><div>She did send over a feature wish list 30 minutes before the meeting.&nbsp;&nbsp;It consisted of ½ page … looks like she gave it 10 minutes of thought.</div><div>&nbsp;</div><div>She sent it to the team, but didn’t copy her boss… so I replied to her email (see attached) expressing that we needed way more detail to create specs … and copied her boss. </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},

{
  id: 'log_31', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-27T19:14:28.000Z",  
lastEdit:"2021-01-27T19:14:28.000Z",  
  timeLock:  "2021-01-27T19:14:28.000Z",  

  meta: '<div>my office</div>',
  title: '',
 
  detail : '<div>Cyn stormed into my office today.&nbsp;She was livid about that last email and that I made her look bad to her boss.</div><div>She informed me that from now on any team requests from me needed to be in writing.&nbsp;She then walked out.&nbsp;I didn’t even get to say a word. </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},



{
  id: 'log_32', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-01-28T19:14:28.000Z",  
lastEdit:"2021-01-28T19:14:28.000Z",  
  timeLock:'',

  meta: '<div>copied boss</div>',
  title: '',
 
  detail : '<div>Send a second request (in writing) for the detailed feature list.  Copied the team and her boss. </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},

{
  id: 'log_33', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-02-03T19:11:16.000Z",  
lastEdit:"2021-02-03T19:11:16.000Z",  
  timeLock:'',

  meta: '',
  title: '',
 
  detail : '<div>Cyn sent the feature list and attended the team meeting yesterday.  She was clearly not happy to be there and wouldn’t even talk to me.  But she and engineering were able to agree on minimum feature list. </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_34', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-02-10T19:09:46.000Z",  
lastEdit:"2021-02-10T19:09:46.000Z",  
  timeLock:'',

  meta: '<div>email exchange </div>',
  title: '',
 
  detail : '<div><div> Conflict between Mark (engineering) and Cyn yesterday.&nbsp;Cyn said she didn’t agree with Mark’s email confirming the MVP feature list.&nbsp;She expressed that he had clearly omitted one feature.&nbsp;Rather than working it out with Mark some time during the week, she chose to wait until the meeting to bring it up.</div><div>&nbsp;</div><div>Although Mark’s email was accurate, <span style="color: rgb(0, 138, 0);">the feature Cyn wanted included but omitted the first round is a good one and should be included in the initial prototype</span>.</div><div> </div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_35', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-02-16T19:05:33.000Z",  
lastEdit:"2021-02-16T19:05:33.000Z",  
  timeLock:'',

  meta: '<div>meeting - conference room</div>',
  title: '',
 
  detail : '<div><strong style="color: rgb(230, 0, 0);">Cyn missed another meeting.&nbsp;</strong>I brought it up when we passed in the hall… her reason was since she had no deliverables, her attendance wasn’t mandatory... and she had a deadline for her boss on another matter.</div><div>&nbsp;</div><div>I let it pass … but clearly this isn’t working well .&nbsp;But this particular team ends in a month… so think we can ride it out.&nbsp;</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


{
  id: 'log_36', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_1', //Cyn 

logDate: "2021-02-22T19:07:36.000Z",  
lastEdit:"2021-02-22T19:07:36.000Z",  
  timeLock:'',

  meta: '<div>meeting - conference room</div>',
  title: '',
 
  detail : '<div><strong style="color: rgb(0, 138, 0);" class="ql-size-large">Cynthia no longer with company.</strong></div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['marketing'],

},


// ----- Mark D  -------------------------------------


{
  id: 'log_37', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_2', //Mark 

logDate: "2021-01-05T19:07:36.000Z",  
lastEdit:"2021-01-05T19:07:36.000Z",  
  timeLock:'',

  meta: '<div>meeting - my office</div>',
  title: '',
 
  detail : '<div>One on one with Mark (engineering representative)… We discussed what was needed for him to create a prototype.&nbsp;</div><div>&nbsp;</div><div>He needs a feature list and a target price for the end product.&nbsp;<span style="color: rgb(153, 51, 255);">He also wanted Linda on the team.&nbsp;She would handle software design</span>.</div>', 

  attachment: '',

  chitLink: null,
  
  peopleArray: [],
  keywordArray: ['to do'],

},


{
  id: 'log_38', 
  type: 'person', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'person_2', //Mark 

logDate: "2021-02-04T19:07:36.000Z",  
lastEdit:"2021-02-04T19:07:36.000Z",  
  timeLock:'',

  meta: '<div>phone con</div>',
  title: '',
 
  detail : '<div> Mark came through with a detail MVP feature requirements package… just 1 day and excellent work.&nbsp;&nbsp;He said that most of it he had been working on before yesterday’s meeting.&nbsp;So it really didn’t take that long to finish it.&nbsp;<span style="color: rgb(230, 0, 0);">I’m going to let his boss know about his great work</span>.&nbsp;</div>', 

  attachment: '',

  chitLink: {dbCollection: 'twoParty', id: 'tp9'},
  
  peopleArray: [],
  keywordArray: ['to do'],

},



// ----------------ATT ----------------------




{
  id: 'log_2', // group - ATT
  type: 'company', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'group_3', // ATT

  logDate: "2021-01-04T19:09:41.000Z",     
  lastEdit:  "2021-01-04T19:09:41.000Z",    
  timeLock:  '',  // if exists - not editable
  
  meta: '<div>Rep 078WR - 33 - Marcus </div>',
  title: '',
 
  detail : '<div>ATT overbilled me $125.&nbsp;Waited for a ½ hour before getting a rep.&nbsp;Told her about the problem - she said that she corrected it.&nbsp;Took and hour.&nbsp;</div><div>&nbsp;</div><div>Said that I could send a check for the new amount&nbsp;which is $67.22.&nbsp;Just use the same invoice.</div><div>&nbsp;</div><div>Sent in the check and referenced the rep.</div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  
  peopleArray: [],
  keywordArray: ['billing'],
  
},


{
  id: 'log_67', // group - ATT
  type: 'company', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'group_3', // ATT

  logDate: "2021-02-03T19:08:36.000Z",     
  lastEdit:  "2021-02-03T19:08:36.000Z",   
  timeLock:  '',  // if exists - not editable
  
  meta: '<div>Rep XQ774 - 55 - Alicia </div>',
  title: '',
 
  detail : '<div>Not only did this month’s bill show the $125 over billing… but also a $5 penalty for late payment.  Spoke to another rep…told him about my call on 1/4 .  He found the reference and adjusted the bill.  He said go ahead and use February’s invoice and pay  this month’s bill of $83.77 . Another hour shot.</div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  
  peopleArray: [],
  keywordArray: ['billing'],
  
},

{
  id: 'log_68', // group - ATT
  type: 'company', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'group_3', // ATT

  logDate: "2021-03-05T19:09:44.000Z",     
  lastEdit:  "2021-03-05T19:09:44.000Z",   
  timeLock:  '',  // if exists - not editable
  
  meta: '<div>Rep R3812 - 55 - Jerome </div>',
  title: '',
 
  detail : '<div>The last rep did<span style="color: rgb(0, 138, 0);"> fix the $125 overbilling</span>… but the late payment penalty wasn’t fixed … AND … to add insult to injury… they charged me another $5 late fee for not paying the late fee last month. <span style="color: rgb(230, 0, 0);">So now I owe $10 in late fees for an overbilling</span> that they corrected.</div><div>&nbsp;</div><div>Called and explained the problem to the rep… he said he couldn’t fix it… had to refer me to collections… held for 15 minutes… then the line went dead.</div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  
  peopleArray: [],
  keywordArray: ['billing'],
  
},


{
  id: 'log_69', // group - ATT
  type: 'company', // company, group, organization, topic, story, other
  
  
  otherPartyId: 'group_3', // ATT

  logDate: "2021-03-08T19:07:22.000Z",     
  lastEdit:  "2021-03-08T19:07:22.000Z",   
  timeLock:  '',  // if exists - not editable
  
  meta: '<div>rep - TK4YP -63</div><div>collections supervisor - Andy</div>',
  title: '',
 
  detail : '<div>Went through the process again… got a rep … told my problem … sent me to collections … put on hold again… talked to collections supervisor…&nbsp;supposedly problem fixed… </div><div>&nbsp;</div><div><span style="color: rgb(153, 51, 255);">I told him if the next bill reflects the overbilling or any late fees I would switch to T-Mobile.</span>&nbsp;</div>', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
  
  peopleArray: [],
  keywordArray: ['billing'],
  
},
// ---------- IRS --------------------------


{
  id: 'log_11', // group org - IRS
  type: 'organization', // company, group, organization, other
  
  
  otherPartyId: 'group_1',

  logDate: "2021-01-06T11:01:00.000Z",  // date input by user
  lastEdit:  "2021-01-06T11:01:00.000Z",  // Jan 6 2021 11:01 AM
  timeLock:  "",  // if exists - not editable
  
  meta: '<div>Return letter sent 1/5/21</div>',
  title: '',
 
  detail : '<div>IRS sent me a letter saying I owed $1540 in taxes from 2019.</div><div>I used Turbo Tax... so I sent them a letter back saying so.</div><div><br></div><div>Sent a duplicate of 1040 asking them where the discrepancy is.</div', 

  attachment: '',

  chitLink: null, //{dbCollection: 'twoPartyChits', id: 'XYZ'}
 peopleArray: [], 
  
  keywordArray: ['taxes'],

},

// 2 =================================================================















// 3 =================================================================














]// end SampleLogs

export default SampleLogs